import { GetTranslationData } from "../GetTranslationData/GetTranslationData ";
import { clientType } from "../Utility/Utility";

const getTranslation = () => ({
  bonusPointsNoHiddenCharges: GetTranslationData(
    clientType,
    "bonus_points_no_hidden_charges"
  ),
  congratulations: GetTranslationData(clientType, "congratulations"),
  welcomeBonusRedeemed: GetTranslationData(
    clientType,
    "welcome_bonus_redeemed"
  ),
  offerCode: GetTranslationData(clientType, "offer_code"),
  coupon: GetTranslationData(clientType, "coupon"),
  coupons: GetTranslationData(clientType, "coupons"),
  claimNow: GetTranslationData(clientType, "claim_now"),
  generateCode: GetTranslationData(clientType, "generate_code"),
  expiryDate: GetTranslationData(clientType, "expiry_date"),
  viewDetails: GetTranslationData(clientType, "view_details"),
  termsAndConditions: GetTranslationData(clientType, "terms_and_conditions"),
  checkValidity: GetTranslationData(clientType, "check_validity"),
  shopByCategory: GetTranslationData(clientType, "shop_by_category"),
  shopByBrands: GetTranslationData(clientType, "shop_by_brands"),
  clearFilter: GetTranslationData(clientType, "clear_filter"),
  apply: GetTranslationData(clientType, "apply"),
  viewAll: GetTranslationData(clientType, "view_all"),
  earnUpTo: GetTranslationData(clientType, "earn_up_to"),
  more: GetTranslationData(clientType, "more"),
  eGiftCards: GetTranslationData(clientType, "e_gift_cards"),
  alreadyClaimedGiftCard: GetTranslationData(
    clientType,
    "already_claimed_gift_card"
  ),
  okLabel: GetTranslationData(clientType, "ok_label"),
  howToRedeem: GetTranslationData(clientType, "how_to_redeem"),
  claimIssue: GetTranslationData(clientType, "claim_issue_try_later"),
  rewardsAndDeals: GetTranslationData(clientType, "rewards_and_deals"),
  login: GetTranslationData(clientType, "login"),
  makeDifferenceToday: GetTranslationData(
    clientType,
    "make_a_difference_today"
  ),
  noDataFound: GetTranslationData(clientType, "no_data_found"),
  noItemsToDisplay: GetTranslationData(
    clientType,
    "no_items_to_display_check_later"
  ),
  travelBookings: GetTranslationData(clientType, "travel_bookings"),
  shoppingOrders: GetTranslationData(clientType, "shopping_orders"),
  earn: GetTranslationData(clientType, "earn"),
  buy: GetTranslationData(clientType, "buy"),
  mrp: GetTranslationData(clientType, "mrp"),
  featured: GetTranslationData(clientType, "featured"),
  claim: GetTranslationData(clientType, "claim"),
  purchaseDate: GetTranslationData(clientType, "purchase_date"),
  orderNumber: GetTranslationData(clientType, "order_number"),
  giftCardCode: GetTranslationData(clientType, "gift_card_code"),
  contactUs: GetTranslationData(clientType, "contact_us"),
  filters: GetTranslationData(clientType, "filters"),
  privacyPolicy: GetTranslationData(clientType, "privacy_policy"),
  summerSpecials: GetTranslationData(clientType, "summer_specials"),
  welcomeRewardsExperience: GetTranslationData(
    clientType,
    "welcome_rewards_experience"
  ),
  unlockDealsEasy: GetTranslationData(
    clientType,
    "unlocking_amazing_deals_easy"
  ),
  smartPhonesSmarterRewards: GetTranslationData(
    clientType,
    "smart_phones_smarter_rewards"
  ),
  shopsta: GetTranslationData(clientType, "shopsta"),
  starting: GetTranslationData(clientType, "starting"),
  offLabel: GetTranslationData(clientType, "off_label"),
  home: GetTranslationData(clientType, "home"),
  brand: GetTranslationData(clientType, "brand"),
  morePointsGiftCards: GetTranslationData(
    clientType,
    "more_points_with_gift_cards"
  ),
  points: GetTranslationData(clientType, "points"),
  fathersDayGifts: GetTranslationData(
    clientType,
    "fathers_day_best_value_gifts"
  ),
  zomato: GetTranslationData(clientType, "zomato"),
  foodAndGroceries: GetTranslationData(clientType, "food_and_groceries"),
  rewardPoints: GetTranslationData(clientType, "reward_points"),
  availableRewardPoints: GetTranslationData(
    clientType,
    "available_reward_points"
  ),
  redeemableRewardPoints: GetTranslationData(
    clientType,
    "redeemable_reward_points"
  ),
  totalRewardPoints: GetTranslationData(clientType, "total_reward_points"),
  myOffersBenefits: GetTranslationData(clientType, "my_offers_benefits"),
  myOrdersAndBookings: GetTranslationData(clientType, "my_orders_bookings"),
  voucherHistory: GetTranslationData(clientType, "voucher_history"),
  till11thMarch2025: GetTranslationData(clientType, "till_11th_march_2025"),
  karmaPoints: GetTranslationData(clientType, "karma_points"),
  allLabel: GetTranslationData(clientType, "all"),
  offers: GetTranslationData(clientType, "offers"),
  giftCards: GetTranslationData(clientType, "gift_cards"),
  copiedSuccessfully: GetTranslationData(clientType, "copied_successfully"),
  welcomeBenefits: GetTranslationData(clientType, "welcome_benefits"),
  validity: GetTranslationData(clientType, "validity"),
  couponCode: GetTranslationData(clientType, "coupon_code"),
  redeem: GetTranslationData(clientType, "redeem"),
  denomination: GetTranslationData(clientType, "denomination"),
  quantity: GetTranslationData(clientType, "quantity"),
  giftCardUsageInstructions: GetTranslationData(
    clientType,
    "gift_card_usage_instructions"
  ),
  cardUsed: GetTranslationData(clientType, "card_used"),
  viewLess: GetTranslationData(clientType, "view_less"),
  viewMore: GetTranslationData(clientType, "view_more"),
  chooseYourCard: GetTranslationData(clientType, "choose_your_card"),
  creditCards: GetTranslationData(clientType, "credit_cards"),
  tryAgain: GetTranslationData(clientType, "try_again"),
  viewPoints: GetTranslationData(clientType, "view_points"),
  pts: GetTranslationData(clientType, "pts"),
  accounts: GetTranslationData(clientType, "accounts"),
  savingsAccount: GetTranslationData(clientType, "savings_account"),
  savingsCard: GetTranslationData(clientType, "savings_card"),
  noCardsAvailable: GetTranslationData(clientType, "no_cards_available"),
  otherCards: GetTranslationData(clientType, "other_cards"),
  valitTill: GetTranslationData(clientType, "valid_till"),
  copyright: GetTranslationData(clientType, "copyright"),
  custCapCopyright: GetTranslationData(
    clientType,
    "custcap_solutions_all_rights_reserved"
  ),
  maleLabel: GetTranslationData(clientType, "Male_label"),
  femaleLabel: GetTranslationData(clientType, "Female_label"),
  validOnlyToday: GetTranslationData(clientType, "valid_only_today"),
  validOnWeekdays: GetTranslationData(clientType, "valid_on_weekdays"),
  validOnWeekends: GetTranslationData(clientType, "valid_on_weekends"),

  networkCardType: GetTranslationData(clientType, "network_card_type"),
  rupay: GetTranslationData(clientType, "rupay_client"),
  specialType: GetTranslationData(clientType, "special_type_client"),
  static: GetTranslationData(clientType, "static_client"),
  noCode: GetTranslationData(clientType, "no_code_client"),
  dynamic: GetTranslationData(clientType, "dynamic_client"),
  feature: GetTranslationData(clientType, "feature_client"),
  filter: GetTranslationData(clientType, "filter"),
  membership: GetTranslationData(clientType, "membership_client"),
  emi_offers: GetTranslationData(clientType, "emi_offers"),
  emi: GetTranslationData(clientType, "emi"),
  offerLabel: GetTranslationData(clientType, "offer_label"),
  dealLabel: GetTranslationData(clientType, "deal_label"),



  products: GetTranslationData(clientType, "products"), // Products
  or: GetTranslationData(clientType, "or"), // Or
  promoMessage: GetTranslationData(clientType, "promo_message"), // Promo Message
  customerCards: GetTranslationData(clientType, "customer_cards"), // Customer Cards
  promoBanner: GetTranslationData(clientType, "promo_banner"), // Promo Banner
  customerMenu: GetTranslationData(clientType, "customer_menu"), // Customer Menu
  specialSection: GetTranslationData(clientType, "special_section"), // Special Section
  specialCartBanner: GetTranslationData(clientType, "special_cart_banner"), // Special Cart Banner
  internalServerError: GetTranslationData(clientType, "internal_server_error"),
  noPermissionContactAdmin: GetTranslationData(clientType, "no_permission_contact_admin"),
  backToHome: GetTranslationData(clientType, "back_to_home"),
  showDetails: GetTranslationData(clientType, "show_details"),
  hideDetails: GetTranslationData(clientType, "hide_details"),
  about: GetTranslationData(clientType, "about"),
  reward: GetTranslationData(clientType, "reward"),
  welcomeOffer: GetTranslationData(clientType, "welcome_offer"),
  hey: GetTranslationData(clientType, "hey"),
  rewardText: GetTranslationData(clientType, "rewardText"),
  homeTitle: GetTranslationData(clientType, "homeTitle"),
  homeDescription: GetTranslationData(clientType, "homeDescription"),
  dealTitle: GetTranslationData(clientType, "dealTitle"),
  dealDescription: GetTranslationData(clientType, "dealDescription"),
  homePageHeader: GetTranslationData(clientType, "home_page_header") || "Home Page Header",
  myAccount: GetTranslationData(clientType, "my_account"),
  myAccountSubhead: GetTranslationData(clientType, "my_account_subhead"),
  YourProducts: GetTranslationData(clientType, "your_products"),
  GetSavingAccount: GetTranslationData(clientType, "getsavingsaccount"),
  GetCreditCard: GetTranslationData(clientType, "getcreditcard"),
  Get750off: GetTranslationData(clientType, "get750off"),
  myActivity: GetTranslationData(clientType, "my_activity"),
  myActivitySubhead: GetTranslationData(clientType, "my_activity_subhead"),
  gotit: GetTranslationData(clientType, "got_it"),
  flight: GetTranslationData(clientType, "flight"),
  hotel: GetTranslationData(clientType, "hotel"),
  shopping: GetTranslationData(clientType, "shopping"),
  voucher: GetTranslationData(clientType, "voucher"),
  benefits: GetTranslationData(clientType, "benefits"),
  karmapoints: GetTranslationData(clientType, "karmapoints"),
  claimYourBenefits: GetTranslationData(clientType, "claim_your_benefits"),
  Get750offCC: GetTranslationData(clientType, "Get750offCC"),
  helpSupport: GetTranslationData(clientType, "help_support"),
  tripstacc_support_heading: GetTranslationData(clientType, "tripstacc_support_heading"),
  contact_number_tripstacc: GetTranslationData(clientType, "contact_number_tripstacc"),
  email_address_tripstacc: GetTranslationData(clientType, "email_address_tripstacc"),
  shopstacc_support_heading: GetTranslationData(clientType, "shopstacc_support_heading"),
  contact_number_shopstacc: GetTranslationData(clientType, "contact_number_shopstacc"),
  email_address_shopstacc: GetTranslationData(clientType, "email_address_shopstacc"),
  redeemOfferMessage: GetTranslationData(clientType, "redeem_offer_message"),
  layout1_label: GetTranslationData(clientType, "layout1_label"),
  layout2_label: GetTranslationData(clientType, "layout2_label"),
  layout3_label: GetTranslationData(clientType, "layout3_label"),
  layout_type_chnage_warning: GetTranslationData(clientType, "layout_type_chnage_warning"),
  totalRewardsPoints: GetTranslationData(clientType, "total_rewards_points"),
  viewLess: GetTranslationData(clientType, "view_less"),
  savingsAc: GetTranslationData(clientType, "savings_ac"),
  membership_normal: GetTranslationData(clientType, "membership_normal"),
  membership_hotel: GetTranslationData(clientType, "membership_hotel"),
  Mr: GetTranslationData(clientType, "Mr"),
  Mrs: GetTranslationData(clientType, "Mrs"),
  Ms: GetTranslationData(clientType, "Ms"),
  HotelMemberhsipDetailPopupHeader: GetTranslationData(clientType, "HotelMemberhsipDetailPopupHeader"),
  HotelMemberhsipDetailPopupSubHeader: GetTranslationData(clientType, "HotelMemberhsipDetailPopupSubHeader"),
  Confirm: GetTranslationData(clientType, "Confirm"),
  ClaimReferenceNo: GetTranslationData(clientType, "ClaimReferenceNo"),
  HotelMembershipSuccessHeading: GetTranslationData(clientType, "HotelMembershipSuccessHeading"),
  claim_initiated: GetTranslationData(clientType, "claim_initiated"),
  benefit_allotted: GetTranslationData(clientType, "benefit_allotted"),
  failed: GetTranslationData(clientType, "failed"),
  benifitName: GetTranslationData(clientType, "benifitName"),
  credit_card: GetTranslationData(clientType, "credit_card"),
  offerSubTypeColumnName: GetTranslationData(clientType, "offerSubTypeColumnName"),
  offerCategory: GetTranslationData(clientType, "offerCategory"),
  offerSubType: GetTranslationData(clientType, "offerSubType"),
  offerSection: GetTranslationData(clientType, "OfferSection"),
  disclaimerProcessBtn: GetTranslationData(clientType, "disclaimerProcessBtn"),
  termsAndCondition: GetTranslationData(clientType, "terms_and_condition"),
  gcidText: GetTranslationData(clientType, "gcidText"),
  pinText: GetTranslationData(clientType, "pinText"),
  skipTour: GetTranslationData(clientType, "skipTour") || "Skip Tour",
  previous: GetTranslationData(clientType, "previous") || "Previous",
  next: GetTranslationData(clientType, "next") || "Next",
  getStarted: GetTranslationData(clientType, "getStarted") || "Get Started",
  step: GetTranslationData(clientType, "step") || "Step",
  of: GetTranslationData(clientType, "of") || "of",
});


export default getTranslation;
